<article class="template-save-form">
  <header>
    <h3 class="form-sub-header" i18n>Save template</h3>
  </header>

  <form class="skideo-form" (submit)="confirm($event)">
    <div class="skideo-form-row save">
      <label for="template-name" i18n>Template name</label>
      <input
        type="text"
        id="template-name"
        [formControl]="templateName"
        placeholder="Your template name"
        autocomplete="off"
        i18n-placeholder />
    </div>

    <footer class="button-wrapper">
      <button type="button" class="skideo-flat-button white" (click)="closeModal()" i18n>Cancel</button>
      <button type="submit" class="skideo-flat-button green" (click)="confirm($event)" i18n>Save</button>
    </footer>
  </form>
</article>
